import { apiService } from './api';
import { TeacherWorkScheduleDTO } from '../types/workingSchedule';

export async function getTeacherSchedule(teacherId: string | number): Promise<TeacherWorkScheduleDTO> {
  const resp = await apiService.get<any>(`/super-admin/api/teachers/${teacherId}/working-schedule`);
  // API may return the DTO directly or wrapped {data}
  return (resp?.data ?? resp) as TeacherWorkScheduleDTO;
}

export async function updateTeacherSchedule(teacherId: string | number, dto: TeacherWorkScheduleDTO): Promise<TeacherWorkScheduleDTO> {
  const resp = await apiService.put<any>(`/super-admin/api/teachers/${teacherId}/working-schedule`, dto);
  return (resp?.data ?? resp) as TeacherWorkScheduleDTO;
}

export async function getMySchedule(): Promise<TeacherWorkScheduleDTO> {
  const resp = await apiService.get<any>(`/api/teacher/working-schedule`);
  return (resp?.data ?? resp) as TeacherWorkScheduleDTO;
}

export async function updateMySchedule(dto: TeacherWorkScheduleDTO): Promise<TeacherWorkScheduleDTO> {
  const resp = await apiService.put<any>(`/api/teacher/working-schedule`, dto);
  return (resp?.data ?? resp) as TeacherWorkScheduleDTO;
}
